export type SpotStep = { text:string; command?:string; check?:boolean; signIn?:boolean };
export type SpotRunOutcome = 'typed'|'busy'|'detached';
export type SpotLevelHelp = {
  key:string; sessionId:string; available:boolean; canHint?:boolean;
  nextStep():Promise<SpotStep>;
  hint():Promise<SpotStep>;
  run(step:SpotStep):Promise<SpotRunOutcome>;
  signIn():void;
};
let level:SpotLevelHelp|undefined;
const listeners=new Set<()=>void>();
export function getSpotLevel(){return level;}
export function onSpotLevelChange(listener:()=>void){listeners.add(listener);return ()=>{listeners.delete(listener);};}
export function registerSpotLevel(value:SpotLevelHelp){
  level=value;listeners.forEach(listener=>listener());
  return ()=>{if(level===value){level=undefined;listeners.forEach(listener=>listener());}};
}
type TerminalBridge = { run(command:string):SpotRunOutcome; target():Promise<HTMLElement|null> };
const terminals=new Map<string,TerminalBridge>();
export function registerSpotTerminal(sessionId:string,terminal:TerminalBridge){
  terminals.set(sessionId,terminal);return ()=>{if(terminals.get(sessionId)===terminal)terminals.delete(sessionId);};
}
export function spotTerminal(sessionId:string){return terminals.get(sessionId);}

/** Only one explicitly formatted shell command; prose and placeholders are never typed. */
export function spotSuggestedCommand(text:string,explicit?:string):string|undefined {
  const blocks=[...text.matchAll(/```(?:bash|sh|shell|console)?[ \t]*\n([^]*?)\n```/g)];
  const inline=[...text.matchAll(/(?<!`)`([^`\n]+)`(?!`)/g)];
  const value=explicit?.trim()||(blocks.length===1?blocks[0]![1]!.trim():blocks.length===0&&inline.length===1?inline[0]![1]!.trim():undefined);
  if(!value||value.length>2000||/[\x00-\x1f\x7f]/.test(value)||/\b(?:FILE|PATH|COMMAND|YOUR_[A-Z_]+)\b|<[^>]+>|\.\.\./.test(value))return;
  return value.replace(/^\$ /,'');
}
export type SpotIntent='hide'|'help'|'sister'|'trick'|'boop'|'explore'|'stay'|'hello'|'thanks'|'unknown';
export function spotIntent(text:string):SpotIntent {
  const value=text.trim().toLocaleLowerCase().replace(/[!?.,。！؟]+$/u,'');
  if(/^(hide|bye|goodbye|sleep|إخفاء|اختفي|باي|verstecken|tschüss|隠れて|おやすみ)$/u.test(value))return 'hide';
  if(/\b(help|stuck|next step|hint)\b|عالق|مساعدة|ساعد|تلميح|hilfe|feststeck|ヒント|助け/u.test(value))return 'help';
  if(/\b(iris|sister)\b|آيريس|أخت|schwester|アイリス|お姉/u.test(value))return 'sister';
  if(/\b(trick|fly|dance|roll)\b|طر|طيران|رقصة|flieg|kunststück|飛んで|ダンス/u.test(value))return 'trick';
  if(/^(explore|roam|تجوّل|تجول|erkunden|探検)$/u.test(value))return 'explore';
  if(/^(stay|sit|ابق|bleib|ここにいて)$/u.test(value))return 'stay';
  if(/\b(boop|poke)\b|لمسة|つんつん/u.test(value))return 'boop';
  if(/\b(thanks|thank you)\b|شكر|danke|ありがとう/u.test(value))return 'thanks';
  if(/^(hi|hello|hey|أهلا|أهلًا|مرحبا|مرحبًا|hallo|こんにちは|やあ)( spot| سبوت)?$/u.test(value))return 'hello';
  return 'unknown';
}
